import { useQuery } from 'react-query';
import { getUserIdByEmail } from '../apis/tms/user.api';
import { TMS_USER_ID } from '../constant/QueryKeyName';

const useGetTMSUserIdByEmail = (email: string) => {
  const queryReturn = useQuery<string, Error, string>(
    [TMS_USER_ID, email],
    () => getUserIdByEmail(email),
    {
      enabled: !!email,
      retry: false,
      refetchOnMount: true,
      cacheTime: 60 * 60, // 1mins
    }
  );

  return { queryReturn };
};

export default useGetTMSUserIdByEmail;
